import { Injector } from '@angular/core';

export class BaseInjector {
	static injector: Injector;
}
